import React from 'react'

const BooksPage = () => {
  return (
    <>
    
    <p className='text-danger p-50 text-center'>No Books</p>
    <p className='h-100'></p>
  <p className='h-100'></p>
  <p className='h-100'></p>
  <p className='h-100'></p>
  <p className='h-100'></p>
  

    </>
  )
}

export default BooksPage